import { Component, inject, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SettlementsService } from 'src/app/services/settlements.service';
import { environment } from 'src/environments/environment';
import { IconsService } from 'src/app/shared/services/icons.service';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { Bill } from 'src/app/models/bill.model';
import { StorageService, STORAGE_KEYS } from 'src/app/services/storage.service';

@Component({
  selector: 'app-tenant-payments',
  template: `
    <div class="d-flex mb-4 mt-4">
      <div class="flex-fill">
        <h1>Historial de pagos</h1>
      </div>
      <div class="col-md-7 mt-4 text-end">
        
        <!-- button class="btn btn-primary btn-lg rounded-5 ms-3" routerLink="/bills/new">Crear recibo</!-->
      </div>
      <!-- xng-breadcrumb ></!-->
    </div>
    <div class="d-flex">
      <div #pages class="flex-fill">
        <div class="d-flex">
          <div>
            <div ngbDropdown class="d-inline-block" (click)="datepicker.toggle()">
              <button type="button" class="btn btn-zazz-default rounded-4 px-4 shadow-sm" id="dropdownForm1" ngbDropdownToggle>
                <fa-icon [icon]="icons.faCalendarAlt" class="me-2"></fa-icon>
                Este mes
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownForm1" class="shadow" style="width: 650px;">
                <div class="row">
                  <div class="col-3">
                    <ul class="list-group calendar-list-group ps-2 mt-2">
                      <li class="list-group-item list-group-item-action active">Hoy</li>
                      <li class="list-group-item list-group-item-action">Ayer</li>
                      <li class="list-group-item list-group-item-action">Este mes</li>
                      <li class="list-group-item list-group-item-action">Últimos 7 días</li>
                      <li class="list-group-item list-group-item-action">Últimos 30 días</li>
                      <li class="list-group-item list-group-item-action">Personalizado</li>
                    </ul>
                  </div>
                  <div class="col-9" style="height: 320px;">
                    <div class="input-group">
                      <input
                        #dpFromDate
                        class="form-control"
                        style="width: 0px !important; height: 0px !important; opacity: 0;"
                        ngbDatepicker
                        #datepicker="ngbDatepicker"
                        [autoClose]="'outside'"
                        (dateSelect)="onDateSelection($event)"
                        [displayMonths]="2"
                        [dayTemplate]="t"
                        outsideDays="hidden"
                        [startDate]="fromDate!"
                        tabindex="-1" 
                      />
                      <ng-template #t let-date let-focused="focused">
                        <span
                          class="custom-day"
                          [class.focused]="focused"
                          [class.range]="isRange(date)"
                          [class.faded]="isHovered(date) || isInside(date)"
                          (mouseenter)="hoveredDate = date"
                          (mouseleave)="hoveredDate = null"
                        >
                          {{ date.day }}
                        </span>
                      </ng-template>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="dropdown-divider"></div>
                    <div class="d-flex text-end flex-fill flex-row-reverse me-2">
                      <button type="button" class="btn btn-zazz-dark ms-2 rounded-4 shadow-sm btn-sm px-4">Aplicar</button>
                      <button type="button" class="btn btn-zazz-default rounded-4 shadow-sm btn-sm px-4">Cancelar</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="list-group rounded-2 shadow mt-4" *ngIf="bills.length > 0">          
          <div class="list-group-item">
            <table class="table table-sm">
              <thead class="thead-dark">
                <tr class="">
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2"># Transacción <button class="btn p-0 text-light"><fa-icon [icon]="icons.faSort"></fa-icon></button></th>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2">Unidad </th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Consumo</th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Pago <button class="btn p-0 text-light"><fa-icon [icon]="icons.faSort"></fa-icon></button></th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Fecha pago</th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Estatus</th>
                  <th scope="col" class="bg-zazz align-items-center align-middle text-light py-2"></th>
                </tr>
              </thead>
              <tbody>
                <tr app-tr-payments 
                  [bill]="bill"
                  [permissions]="permissions"
                  (updateDate)="updateBillDate($event)"
                  *ngFor="let bill of bills | paginate: { itemsPerPage: payload.per_page, currentPage: p, totalItems: meta.total_entries }"
                ></tr>
              </tbody>
            </table>
          </div>

          <div class="list-group-item p-0" *ngIf="bills.length==0&&loading">
            <fa-icon [icon]="icons.faCircleNotch" size="2x" animation="spin" class="text-secondary"></fa-icon>
            <p class="text-muted">Cargando...</p>
          </div>
          <div class="list-group-item text-center" *ngIf="bills.length==0&&!loading">
            <img src="/assets/images/empty-state.png" width="240px">
            <p class="text-muted">No se encontraron registros</p>
          </div>
          <div class="list-group-item text-center" *ngIf="bills.length>0">
            <pagination-controls
              (pageChange)="p = $event"
              (pageChange)="pageChanged($event)"
              previousLabel="Prev."
              nextLabel="Sig."
              screenReaderPaginationLabel="Pagination"
              screenReaderPageLabel="page"
            ></pagination-controls>
          </div>
        </div>
      </div>
    </div>
    <!-- app-item-transaction [bill]="bill" [permissions]="permissions"></app-item-transaction -->
  `,
  styleUrls: []
})
export class TenantPaymentsComponent implements OnInit {
  bills: Bill[] = [];
  verifyBill: any = [];
  verifyMeta: any = [];
  meta: any = [];
  tenant: any = {};
  permissions: any = {};
  loading: boolean = false;

  apiUrl: string = environment.AWS_REST_WSPREFIX;

  payload: any = {
    page: 1,
    per_page: 10,
    status: true,
    state: [1,2],
    sort: 'created_at',
    order: 'DESC'
  };

  p: number = 1;

  a = new Date();
  fromDate;
  toDate: NgbDate | null;
  hoveredDate: NgbDate | null = null;
  storageService = inject(StorageService);
  constructor (
    private store : SettlementsService,
    private activateRoute: ActivatedRoute,
    private route: Router,
    public icons: IconsService
  ) {
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) ? this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) : null;

    const adjustedDate = new Date(this.a.getFullYear(), this.a.getMonth(), this.a.getDate());
    const lastDay = new Date(this.a.getFullYear(), this.a.getMonth() + 1, 0);

    this.fromDate = new NgbDate(adjustedDate.getFullYear()-1, adjustedDate.getMonth()+1, 1);
    this.toDate = new NgbDate(this.a.getFullYear(), this.a.getMonth()+1, lastDay.getDate());

    this.payload.created_at_since = this.fromDate.year + '-' + this.fromDate.month + '-' + this.fromDate.day;
    this.payload.created_at_to = this.toDate.year + '-' + this.toDate.month + '-' + this.toDate.day;
  }

  ngOnInit(): void {
    this.loading = true;
    this.activateRoute.params.subscribe((params: any) => {
      this.store.getTenant(params['id']).subscribe((data: any) => {
        this.tenant = data;
        console.log('TENANT => ', data);
        this.payload.units = data.units.map((item: any) => item.id);
        console.log('PAYLOAD UNITS => ', this.payload.units);
        this.loadBills(this.payload);
      });
    });
  }

  loadBills(payload: any) {
    this.store.getBillsByUnit(payload.unit_id, {
      page: 1,
      per_page: 100,
      status: false,
      state: 3,
      invoiced: false,
      created_at_since: this.payload.created_at_since,
      created_at_to: this.payload.created_at_to
    }).subscribe({
      next: (bills: any) => {
        this.verifyBill = bills.data;
        this.loading = false;
      }, error: (error: any) => {
        console.error(error);
        this.loading = false;
      }
    });
    this.store.getTransactionsByUnit(payload.unit_id, payload)
      .subscribe({
        next: (bills: any) => {
        console.log('bills => ', bills);
        this.bills = bills.data;
        this.loading = false;
      }, error: (error: any) => {
        console.error(error);
        this.bills = [];
        this.loading = false; 
      }
    });
  }

  gotoPayment(bill: any) {
    this.route.navigate(['/tenant/bill', bill.id]);
  }

  pageChanged(event: any) {
    this.payload.page = event;
    this.loadBills(this.payload);
  }

  openFilters() {}

  updateBillDate(event: any) {}

  async downloadReceipt(bill: any) {
    console.log("downloadReceipt BILLL ===========")
    console.log(bill);

    // let unitData: any = {};
    // let buildingData: any = {};

    let dueDate = new Date(bill.due_date);
    dueDate.setDate(dueDate.getDate());
    dueDate.toISOString().substring(0, 10);

    console.log('dueDate => ', dueDate);

    this.store.getSubscriptions(bill.subscription_id).subscribe((data: any) => {
      console.log('getSubscription => ', data);      
      this.store.getUnit(data.unit_id).subscribe((unitData: any) => {
        // ! TODO: Refactor this is old code
        console.log('getTenantByUnit => ', data);
        this.store.getBuilding(1).subscribe(async (data: any) => {
          // console.log('getBuilding => ', data);
          if (bill.images && bill.images.length > 0) {
          let imageUrl = `${this.apiUrl}/storage/${bill.images[0].blob.key.substring(0,2)}/${bill.images[0].blob.key.substring(2,4)}/${bill.images[0].blob.key}`
          let imageUrl2 = `${this.apiUrl}/storage/${bill.images[1].blob.key.substring(0,2)}/${bill.images[1].blob.key.substring(2,4)}/${bill.images[1].blob.key}`

          await this.getBase64ImageFromUrl(imageUrl)
          .then(result => {
            let blobed = result;
            bill.image1 = blobed;
            console.log("BLOBED => ", blobed);
          })

          await this.getBase64ImageFromUrl(imageUrl2)
          .then(result => {
            let blobed = result;
            bill.image2 = blobed;
            // console.log("BLOBED => ", blobed);
          })
          .catch(err => console.error(err));
        }

          const payload = {
            bill: bill,
            dueDate: dueDate,
            unitData: unitData,
            buildingData: data
          };
  
          this.store.createReceipt(payload).subscribe({
            next: (data: any) => {
              console.log('createReceipt => ', data);
              // const payload = JSON.parse(data.result.data);
              // const buffer = payload.result.data;
              // console.log('buffer => ', buffer);
  
              // const byteString = window.atob(buffer);
              // const arrayBuffer = new ArrayBuffer(byteString.length);
              const int8Array = new Uint8Array(data.result.data);
              // for (let i = 0; i < byteString.length; i++) {
                // int8Array[i] = byteString.charCodeAt(i);
              // }
              const blob = new Blob([int8Array], { type: 'application/pdf' });
              console.log("blob ===> ", blob);
  
              var fileURL = window.URL.createObjectURL(blob);
              
              // window.download(data, '_blank');
  
              var link=document.createElement('a');
              link.href = fileURL;
              link.download = data.filename; // filePath.substr(filePath.lastIndexOf('/') + 1);
              link.click();
  
              return;
  
              // var file = new Blob([buffer.blob()], {type: 'application/pdf'});
              // var fileURL = window.URL.createObjectURL(file);
              // window.open(data, '_blank');
  
  
              // window.open(data, '_blank');
            }, error: (error: any) => {
              console.log('createReceipt ERROR => ', error);
            }
          });

          // this.createReceipt(bill, dueDate, unitData, data);
        });
      });
    });
  }

  async getBase64ImageFromUrl(imageUrl: any) {
    var res = await fetch(imageUrl);
    var blob = await res.blob();
  
    return new Promise((resolve, reject) => {
      var reader  = new FileReader();
      reader.addEventListener("load", function () {
          resolve(reader.result);
      }, false);
  
      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(blob);
    })
  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
			this.fromDate = date;
		} else if (this.fromDate && !this.toDate && date) {
      this.toDate = date;
      if (this.fromDate.after(this.toDate)) {
        // If fromDate is after toDate, swap them
        const temp = this.fromDate;
        this.fromDate = this.toDate;
        this.toDate = temp;
      }
		} else {
			this.toDate = null;
			this.fromDate = date;
		}

    if (this.fromDate && this.toDate) {
      this.payload.created_at_since = `${this.fromDate.year}-${this.fromDate.month}-${this.fromDate.day}`;
      this.payload.created_at_to = `${this.toDate.year}-${this.toDate.month}-${this.toDate.day}`;
      this.loadBills(this.payload);
    }
	}

	isHovered(date: NgbDate) {
    return (
      this.fromDate && 
      !this.toDate && 
      this.hoveredDate && 
      date.after(this.fromDate) && 
      date.before(this.hoveredDate)
    );
  }

    isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  isInside(date: NgbDate) {
    return this.toDate && 
          date.after(this.fromDate) && 
          date.before(this.toDate);
  }

}
